/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of this package.
 */
export { platformBrowserDynamicTesting, BrowserDynamicTestingModule, ɵDOMTestComponentRenderer, ɵplatformCoreDynamicTesting } from './src/testing';
//# sourceMappingURL=public_api.js.map